import { post, get } from '../Services/http';

export const verifyRecaptcha = (token) => {
    return post('/api/recaptcha/verifyRecaptcha', token);
}

export const getSiteKey = async () => {
    const response = await get('/api/recaptcha/getsitekey')
    return response.text();
}

